// extracted by css-extract-rspack-plugin
export default {"miniPicker":"tTEBW"};